module.exports = __webpack_public_path__ + "static/media/yves-saint-lhomme-parfum-intentse-big.b3942ae0.jpg";